<template>
  <div class="container">
    <div class="nav">
      <Btnav></Btnav>
    </div>

    <div
      class="banner"
      :style=" 'background-image: url(' + this.banner + ');background-size: cover;'"
    ></div>
    <div class="service">
      <div class="service1">
        <p class="servicep">{{ischinese == "cn" ?this.newsarray.title:this.newsarray.title_en}}</p>
        <p class="servicep2">{{this.newsarray.time}}</p>

        <div
          class="servicep3"
          v-html="ischinese == 'cn' ?this.newsarray.content:this.newsarray.content_en"
        ></div>
      </div>
      <div class="service4">
        <div class="service1r">
          <span
            class="newsss"
            v-show="this.lastNew.image != null"
            @click="routerdetails(lastNew.id)"
          >{{one1}}：{{ischinese == "cn" ?this.lastNew.title:this.lastNew.title_en}}</span>
          <br />
          <br />
          <span
            class="newsss"
            v-show="this.nextNew.image != null"
            @click="routerdetails(nextNew.id)"
          >{{one2}}：{{ischinese == "cn" ?this.nextNew.title:this.nextNew.title_en}}</span>
        </div>
        <div class="service1l">
          <router-link to="Anew">
            <div class="more">
              <i class="el-icon-arrow-left"></i>
              <i class="el-icon-arrow-left"></i>
              {{one3}}
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Btfooter></Btfooter>
  </div>
</template>
<script>
import Btnav from "../../components/dashu/nav";
import Btfooter from "../../components/dashu/footer";
export default {
  components: { Btnav, Btfooter },
  data() {
    return {
      ischinese: "cn",
      banner: "",
      newsarray: [],
      lastNew: [{ image: null, title: null, id: null }],
      nextNew: [{ image: null, title: null, id: null }],
      one1: "前一篇",
      one2: "后一篇",
      one3: "返回"
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.one1 = "Last article";
      this.one2 = "Next article";
      this.one3 = "Return";
    }
    // console.log(this.$route.query)
    const id = this.$route.query.detailsid;
    // console.log(id)
    this.$http
      .post("/api/dashu/news/getInfo", {
        id: id
      })
      .then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          const setting = res.data.data;
          this.banner = res.data.data.lists.image[0];
          this.newsarray = setting.lists;
          this.lastNew = setting.lastNew;
          this.nextNew = setting.nextNew;
          // console.log(this.lastNew)
          // console.log(this.nextNew)
        }
      });
  },
  methods: {
    routerdetails(detailsid) {
      this.$router.push({
        name: "Anews",
        query: { detailsid: detailsid }
      });
      this.$http
        .post("/api/dashu/news/getInfo", {
          id: detailsid
        })
        .then(res => {
          if (res.data.code === 0) {
            this.banner = res.data.data.lists.image[0];
            // console.log(res.data.data)
            const setting = res.data.data;
            this.newsarray = setting.lists;
            this.lastNew = setting.lastNew;
            this.nextNew = setting.nextNew;
            // console.log(this.lastNew)
            // console.log(this.nextNew)
          }
        });
    }
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.container {
  background-color: white;
  min-width: max-content;
  min-width: -moz-max-content;
}
.nav {
  overflow: hidden !important;
}
.nav {
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  min-width: 1200px;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
}
.banner {
  overflow: hidden !important;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 890px;
  /* margin-top: 57px; */
}
.service {
  /* width:1900px; */
  background: white;
}
.service1 {
  width: 1200px;
  margin: 0 auto 30px;
}
.servicep {
  font-size: 30px;
  line-height: 30px;
  padding-top: 30px;
  padding-left: 10px;
  text-align: center;
}
.servicep2 {
  font-size: 15px;
  line-height: 30px;
  padding-left: 10px;
  text-align: center;
}
.servicep3 {
  font-size: 16px;
  line-height: 30px;
  padding: 15px;
  text-align: center;
}
.more {
  background: #76c3a2;
  color: white;
  font-size: 15px;
  line-height: 30px;
  /* width: 85px; */
  height: 30px;
  border-radius: 5px;
  position: absolute;
  bottom: 100px;
  top: 65px;
  right: 0;
  padding: 0 9px;
}
.service4 {
  width: 1200px;
  margin: 0 auto 30px;
  display: flex;
}
.service1l {
  width: 685px;
  padding-top: 30px;
  position: relative;
}
.service1r {
  width: 480px;
  padding: 40px 40px 0;
}
.newsss {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Anews.vue